import React from 'react'

import { LntDropdown, LntIconButton } from '@app/components/base'

import { Icon } from '@app/components/util'
import { ICON_NAME } from '@app/constants/icon'
import { BUTTON_TYPE, ICON_SIZE, SIZE } from '@app/constants'

import { isEmptyArray, isNullable } from '@app/utils'

import type { SettingsMenuProps } from './types'

const SettingOutlined: React.FC = () => (
  <Icon
    size={ ICON_SIZE }
    name={ ICON_NAME.setting }
  />
)

export const SettingsMenu: React.FC<SettingsMenuProps> = ({ settings }) => {
  if (isNullable(settings) || isEmptyArray(settings)) return null

  return (
    <LntDropdown
      trigger={ ['click'] }
      items={ settings }
    >
      <LntIconButton
        type={ BUTTON_TYPE.text }
        size={ SIZE.middle }
        icon={ <SettingOutlined /> }
      />
    </LntDropdown>
  )
}
